import React, { Component } from "react";
import SchedulingForm from "../SchedulingForm/SchedulingForm";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : SchedulingPage
Description : Componente que invoca al componente SchedulingForm
Date Autor Modification
================================================================================
14/04/2026 scoca – Creacióm
================================================================================ */
class SchedulingPage extends Component {
    render() {
        return (
            <SchedulingForm />
        )
    }
}

export default SchedulingPage;